export function addToBetSlip(betData) {
  const stored = JSON.parse(localStorage.getItem('betSlipItems') || '[]');
  const exists = stored.some(b => b.id === betData.id);
  if (exists) return false;
  stored.push({ stake: 0, ...betData });
  localStorage.setItem('betSlipItems', JSON.stringify(stored));
  window.dispatchEvent(new Event('betAdded'));
  return true;
}

export function removeFromBetSlip(id) {
  const stored = JSON.parse(localStorage.getItem('betSlipItems') || '[]');
  const updated = stored.filter(b => b.id !== id);
  localStorage.setItem('betSlipItems', JSON.stringify(updated));
  window.dispatchEvent(new Event('betAdded'));
}

export function toggleBetSlip(betData) {
  const stored = JSON.parse(localStorage.getItem('betSlipItems') || '[]');
  const exists = stored.some(b => b.id === betData.id);
  if (exists) {
    const updated = stored.filter(b => b.id !== betData.id);
    localStorage.setItem('betSlipItems', JSON.stringify(updated));
  } else {
    stored.push({ stake: 0, ...betData });
    localStorage.setItem('betSlipItems', JSON.stringify(stored));
  }
  window.dispatchEvent(new Event('betAdded'));
  return !exists;
}

export function getBetSlipCount() {
  return JSON.parse(localStorage.getItem('betSlipItems') || '[]').length;
}

export function isBetSelected(id) {
  const stored = JSON.parse(localStorage.getItem('betSlipItems') || '[]');
  return stored.some(b => b.id === id);
}
